const WORDS = ["ESTRATÉGIA", "PRIORIZAÇÃO", "QUESTÕES", "SIMULADO", "REVISÃO", "MÉTODO", "DESEMPENHO", "TRANSFERÊNCIA UNESP"];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <div className="overflow-hidden bg-brand-navy py-5">
      <div className="flex w-max animate-marquee items-center gap-8 whitespace-nowrap">
        {row.map((w, i) => (
          <div key={i} className="flex items-center gap-8">
            <span className="font-display text-lg font-medium tracking-tight text-white/70 md:text-2xl">
              {w}
            </span>
            <span className="text-brand-gold">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
}
